module.exports = __webpack_public_path__ + "img/feaure.d5ecc95a.jpg";